module.exports = __webpack_public_path__ + "static/img/2.27bd053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/2.png
// module id = jAyS
// module chunks = 0